import Vue from 'vue'
import axios from 'axios'
import store from '@/store/index'
import request from '@/utils/request'
import moment from 'moment'
import CryptoJS from 'crypto-js'; // Ensure this is imported if not already

const headers = {
    headers: {
        Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
    },
}
const apiUrl = process.env.VUE_APP_API_URL
const tempCountry = process.env.VUE_APP_COUNTRY_TEMP
const country = process.env.VUE_APP_COUNTRY
var associateData = []
var cardTypeLists = {
        PK:{
            default: "['PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK', 'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK']",
            URDU: "['PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK']",
            SMART: "['PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK']",
            nicopOld:"['PKR NICOP 0 FRONT','PKR NICOP 0 BACK']",
            nicopNew:"['PKR CNIC 1 FRONT','PKR NICOP 1 BACK']"
        },
        UK: {
            default: "['GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT', 'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK', 'GBR BRP 0 FRONT', 'GBR BRP 0 BACK']",
            passport: "['GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT']",
            passportMRZ:"['NON PT 0 FRONT']",
            brp: "['GBR BRP 0 FRONT', 'GBR BRP 0 BACK']",
            license: "['GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK']",
            qrp: "['QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK']",
            uaeOldResidentCard: "['ARE ID 0 FRONT', 'ARE ID 0 BACK']",
            uaeSmartResidentCard : "['ARE ID 1 FRONT', 'ARE ID 1 BACK']"
        }
    }
let cardTypesForGeneric = [
                           'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                           'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                           'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                           'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                           'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                           'NON PT 0 FRONT'
                         ]
let cardTypesForFatherName = ['PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK','PKR NICOP 0 FRONT','PKR NICOP 1 FRONT']
let cardTypesForIdentityInfo = [
                                 'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                                 'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK','PKR CNIC 1 FRONT',
                                 'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK','PKR NICOP 1 FRONT','PKR NICOP 0 FRONT','PKR NICOP 0 BACK',
                                 'QAT RP 0 FRONT', 'QAT RP 1 FRONT',
                                 'ARE ID 0 FRONT', 'ARE ID 0 BACK', 
                                 'ARE ID 1 FRONT', 'ARE ID 1 BACK'
                                ]

let cardTypesForPassport = [
                             'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                             'NON PT 0 FRONT',
                            ]
let cardTypesForNationality = [
                               'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                               'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                               'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                               'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                               'NON PT 0 FRONT',
                               'QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK',
                               'ARE ID 0 FRONT', 'ARE ID 0 BACK', 
                               'ARE ID 1 FRONT', 'ARE ID 1 BACK'
                            ]
let cardTypesForGender = [ 
                           'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK','PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                           'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                           'NON PT 0 FRONT',
                         ]
let cardTypesForName = [
                        'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                        'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                        'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                        'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                        'NON PT 0 FRONT',
                        'GBR BRP 0 FRONT', 'GBR BRP 0 BACK',
                        'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                       ]
let cardTypesForDob = [
                       'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                       'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                       'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                       'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                       'NON PT 0 FRONT',
                       'GBR BRP 0 FRONT', 'GBR BRP 0 BACK',
                       'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                      ]
let cardTypesForOcrPic = [
                        'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK',
                        'PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK',
                        'PKR NICOP 0 FRONT','PKR NICOP 1 FRONT',
                        'GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT',
                        'NON PT 0 FRONT',
                        'GBR BRP 0 FRONT', 'GBR BRP 0 BACK',
                        'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK',
                       ]
let cardTypeList = null
let documentSummaryDocsList = ['GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT','NON PT 0 FRONT','PKR CNIC 0 FRONT','PKR CNIC 1 FRONT','GBR DL 0 FRONT','GBR DLP 0 FRONT','GBR BRP 0 FRONT']

export async function ocr(value,side, overrideCardType = null, isAuthenticated = false, cardTypeListKey = null) {
    // console.log('My function is called. ocr------------------');

    try {
        let cardType = store.getters.getField('identityInfo.cardType');
        cardTypeList =  ( cardTypeListKey && getCardTypeList(cardTypeListKey ) )|| getCardTypeList(cardType)
        overrideCardType = cardTypeList.includes(overrideCardType) ?  overrideCardType : ""
        let payload = {
            'cardSide':side,
            'cardType': overrideCardType || "",
            'cardTypeList': cardTypeList,
            'filePath':value,
            isAuthenticated
        }
        // console.log('payLoad-->',payload)

        let { data } = await axios.post(apiUrl + 'customers/ocr', payload, headers)


        // let data = {data:{croppedImages:{
        //     'country_of_stay':'Pakistan',
        //     'dob': new Date("Sun Sep 18 2023 17:23:45 GMT+0000 (Coordinated Universal Time)"),
        //     'father_name':'Younus',
        //     'gender':'M',
        //     'id_number':'3-27627462767-3',
        //     'doe': new Date("Sun Dec 18 2023 17:23:45 GMT+0000 (Coordinated Universal Time)"),
        //     'Name':'SAIF'
        // },StatusCode:true}}
        let ocrApiResponse = data.data
        let isValid = data && data.data && data.data.result 
        let isOcr = data.data.ocr && data.data.ocr.result &&  data.data.ocr.ocr_results
        let isFace  = data.data.face && data.data.face.result && data.data.face.face_image
        let isCardType = ocrApiResponse && ocrApiResponse.card_type
        let isDocumentExpired = isValid && ocrApiResponse.document_summary && ocrApiResponse.document_summary.validity==false
        let isBrp = isCardType && cardTypeLists.UK.brp.includes(ocrApiResponse.card_type)
        let isNicopSmartBack = isCardType && ['PKR NICOP 1 BACK'].includes(ocrApiResponse.card_type)
        // let isQatarRpBack = isCardType && cardTypeLists.UK.qrp.includes(ocrApiResponse.card_type) && ocrApiResponse.card_type.includes("BACK")
        
        if( isValid && isOcr && isCardType && !isDocumentExpired)
        {   let respCardType = ocrApiResponse.card_type
            if( isCardType && ocrApiResponse.card_type.includes("FRONT")){
                await ocrFieldReset(ocrApiResponse.card_type)
            }
            let ocrData = data.data.ocr.ocr_results
            // updateNationality(data.data.croppedImages['country_of_stay'])
            // updateDob(data.data.croppedImages['dob'])
            // updateFatherName(data.data.croppedImages['father_name'])
            // updategender(data.data.croppedImages['gender'],data.data.croppedImages['id_number'])
            // updateIdentity(data.data.croppedImages['id_number'],data.data.croppedImages['doe'])
            // updateName(data.data.croppedImages['Name'])
            if(!isBrp && !isNicopSmartBack ){
                    if(cardTypesForName.includes(respCardType) && ( ocrData.name || ocrData.Name || ocrData.given_name || ocrData.first_name || ocrData.full_name )) {
                    await updateName(ocrData.name || ocrData.Name || ocrData.given_name || ocrData.first_name || ocrData.full_name , ocrApiResponse, ocrData )
                    }
                    if(cardTypesForFatherName.includes(respCardType) && ocrData['father_name']){
                        updateFatherName(ocrData['father_name'])
                    }
                    if(cardTypesForGender.includes(respCardType) && (ocrData.sex || ocrData.gender) ) {
                    await updateGender(ocrData.sex || ocrData.gender, '')
                    }
                    if(cardTypesForDob.includes(respCardType) && ( ocrData['Date of birth'] ||  ocrData['dob'] )) {
                        await updateDob(ocrData['dob']|| ocrData['Date of birth'])
                    }
                    if(cardTypesForNationality.includes(respCardType) && await isUpdateField('basicInfo.nationality') &&  ( ocrData['country_of_stay'] || ocrData['nationality'] ) ) {
                        await updateNationality(ocrData['country_of_stay'] || ocrData['nationality'], ocrApiResponse )

                    } 
                    if( ( cardTypesForIdentityInfo.includes(respCardType) || cardTypesForPassport.includes(respCardType) ) 
                        && ( 
                            (ocrData.id_number || ocrData.passport_no || ocrData.license_no || ocrData.permit_no)  
                            ||
                            ( ocrData['doe'] || ocrData.doe || ocrData.passport_expiry) 
                        )
                    ) {
                        await updateIdentity(ocrData.id_number || ocrData.passport_no || ocrData.license_no || ocrData.permit_no ,
                            ocrData['doe'] || ocrData.doe || ocrData.passport_expiry , ocrApiResponse)
                    }
                    
                    if(cardTypesForOcrPic.includes(respCardType) && isFace){
                    await updatePicture(data.data.face.face_image)
                    }
           }
    
            

            // let img='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'
            data.data = await transFormDataformessages(data.data)
            return data.data
        }

        if(side && side.toLowerCase() == 'front' && !isBrp){
            await ocrFieldReset(payload.cardType,payload)
        }
        if( isValid && isDocumentExpired){
            data.data.result = false
            data.data.status_code = 1
        }
      return data.data = await transFormDataformessages(data.data)
    }catch (e) {
        console.log('OCR error 1',e)
        if (e.response && e.response.status === 401 && !isAuthenticated) {
            await store.dispatch('authLogout')
        }
        return await transFormDataformessages({result:false})
    }
}

export async function setDocumetSummary(data = null,key,isReset = false){

    let cardType = store.getters.getField('identityInfo.cardType');
    let isUkPassport =  ['UK'].includes(tempCountry) && cardType == 'passport'&& key == 'identity'
    let isUKIdFront = ['UK'].includes(tempCountry) && (cardType == 'license' || cardType =='brp') && key == 'identity'
    let isUKIdBack = ['UK'].includes(tempCountry) && (cardType == 'license' || cardType =='brp') && key == 'identityBack'
    let isMandatoryPassport = ['UAE','Qatar'].includes(tempCountry) && key == 'identity'
    let isEmiratesIdFront =  ['UAE','Qatar'].includes(tempCountry) && key == 'fieldEmiratesID'
    let isEmiratesIdBack =  ['UAE','Qatar'].includes(tempCountry) && key == 'fieldEmiratesIDBack'
    let isPkIdFornt = ['PK'].includes(tempCountry) && key == 'identity'
    let isPkIdBack = ['PK'].includes(tempCountry) && key == 'identityBack'
  
    if(isReset || data && !data.result){
        if( isMandatoryPassport || isUkPassport){
            store.commit('updateField', {
                key: 'identityInfo.passport.documentSummary',
                value: {}
            })
        }
        else if (isEmiratesIdFront || isPkIdFornt || isUKIdFront){
            store.commit('updateField', {
                key: 'identityInfo.documentSummary',
                value: {}
            })
        }
        else if( isEmiratesIdBack || isPkIdBack || isUKIdBack){
            store.commit('updateField', {
                key: 'identityInfo.documentSummaryBack',
                value: {}
            })
        }
    }else if (data && data.result && data.document_summary){

        if( isMandatoryPassport || isUkPassport){
            data.document_summary.heading = "Passport Document Summary"
            store.commit('updateField', {
                key: 'identityInfo.passport.documentSummary',
                value: data.document_summary
            })
        }
        else if (isEmiratesIdFront || isPkIdFornt || isUKIdFront){
            data.document_summary.heading = "National Id Front Document Summary"
            store.commit('updateField', {
                key: 'identityInfo.documentSummary',
                value: data.document_summary
            })
        }
        else if( isEmiratesIdBack || isPkIdBack || isUKIdBack){
            data.document_summary.heading = "National Id Back Document Summary"
            store.commit('updateField', {
                key: 'identityInfo.documentSummaryBack',
                value: data.document_summary
            })
        }

    }
   
}
export function transFormDataformessages(data,isDocumentSummary = false){
    let messages = []
    if((data.result&& !isDocumentSummary) || isDocumentSummary){
        // {
        //     "card_invalid": null,
        //     "card_partial": null,
        //     "card_side": true,
        //     "damaged": false,
        //     "document_name": "United Kingdom Passport",
        //     "image_quality": 92.99,
        //     "issuing_country": "United Kingdom",
        //     "portrait": true,
        //     "text_fields": null,
        //     "validity": true
        // }
    let {document_summary} = data 
    messages.push({'text':document_summary['document_name']+' detected','icon':'approved'})
    let textQuality = document_summary.image_quality > 90 ? 'Image Quality is Good': document_summary.image_quality > 80 ? 'Image Quality is Average' : 'Image Quality is Poor' 
    messages.push({text:textQuality,'icon':document_summary.image_quality > 80 ? 'approved' : 'warning'})
    let isTextFields = document_summary.missing_text_fields&& document_summary.missing_text_fields.length >0 ? 'warning' :'approved'
    let textFields = isTextFields =='warning' ? 'Text is not clear':'Text is clear'
    messages.push({text:textFields,'icon':isTextFields})
    document_summary.damaged ? messages.push({text:"The card is damage",'icon':'warning'}) : "" 
    document_summary.validity == false ? messages.push({text:"This Card is near to expiry",'icon':'warning'}): ""
    document_summary.portrait ==false ?  messages.push({text:"Can't find face in the card",'icon':'warning'}) :""
    // console.log("From tranformdaTa functions js ",messages)
    
    }else{
        let errorObj = {
            1:"The document has expired, please try again with a current document", 
            900 :"Please upload the correct image format",
            1000:"Oops, we couldn't find any document that matches the type you selected. Please check the document type and ensure you submit correctly",
            1001:"Oops, we found multiple documents uploaded. Please check the document type and ensure you submit the correct type",
            1002:"Sorry, we couldn't detect any documents in the image you provided. Please check the document type and ensure you submit correctly, also please ensure the document is clear and well-centred.",
            1003:"The side of the card you uploaded doesn't match what we expected. We need the specific side indicated, so please make sure you've got the right one",
            1004:"We see the document, but the image quality is a bit blurry. Please upload a clearer picture for verification",
            1005:"Oops, we couldn't find any document that matches the type you selected. Please check the document type and ensure you submit correctly",
            1006:"Sorry, we couldn't detect any documents in the image you provided. Please check the document type and ensure you submit correctly, also please ensure the document is clear and well-centred.",
            1007:"Sorry, we couldn't detect any documents in the image you provided. Please check the document type and ensure you submit correctly, also please ensure the document is clear and well-centred.",
            1008:"Sorry, the document detected is not clear. Please ensure the document is readable and well-centered.",
            1100:"Oops, it looks like there's some damage on the document. Please use a clean, undamaged document",
            2001:"Sorry, we couldn't find a face on the uploaded document. Please upload a clearer image with your face visible",
            3001:"Oops, we had trouble reading the text on the document. Please ensure the document is clear and not damaged.",
            3003:"Oops, we had trouble reading the text on the document. Please ensure the document is clear and not damaged."
          }
          if(errorObj[data.status_code]){
            messages.push({text:errorObj[data.status_code],'icon':'rejected'})
          }else{
            messages.push({text:"Something went wrong. Please try again",'icon':'rejected'})
          }
    }
    data['frontEndMessages'] = messages
    return data

}
function getCardTypeAlias(cardType, cardSide){ //returns null if document has more than one type like passports could be of 3 types
    let tempCountry = process.env.VUE_APP_COUNTRY_TEMP //country code
    if(!tempCountry && process.env.VUE_APP_COUNTRY == "Pakistan"){
        tempCountry = "PK";
    }
    let aliases = {
        // PK: {
        //     URDU: {
        //         FRONT: "PKR CNIC 0 FRONT",
        //         BACK: "PKR CNIC 0 BACK",
        //     },
        //     SMART: {
        //         FRONT: "PKR CNIC 1 FRONT",
        //         BACK: "PKR CNIC 1 BACK",
        //     }
        // },
        // UK: {
        //     // passport: null,
        //     // license: null,
        //     brp: {
        //         FRONT: "GBR BRP 0 FRONT",
        //         BACK: "GBR BRP 0 BACK",
        //     },
        // }
    }
    return aliases[tempCountry] && aliases[tempCountry][cardType] ? aliases[tempCountry][cardType][cardSide] : '' 
}
function getCardTypeList(cardType){
    let tempCountry = process.env.VUE_APP_COUNTRY_TEMP //country code
    if(!tempCountry && process.env.VUE_APP_COUNTRY == "Pakistan"){
        tempCountry = "PK";
    }
    let cardTypeLists = {
        PK:{
            default: "['PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK', 'PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK']",
            URDU: "['PKR CNIC 0 FRONT', 'PKR CNIC 0 BACK']",
            SMART: "['PKR CNIC 1 FRONT', 'PKR CNIC 1 BACK']",
            nicopOld:"['PKR NICOP 0 FRONT','PKR NICOP 0 BACK']",
            nicopNew:"['PKR CNIC 1 FRONT','PKR NICOP 1 BACK']"
        },
        UK: {
            default: "['GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT', 'GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK', 'GBR BRP 0 FRONT', 'GBR BRP 0 BACK']",
            passport: "['GBR PT 2 FRONT',  'GBR PT 1 FRONT', 'GBR PT 0 FRONT','NON PT 0 FRONT']",
            brp: "['GBR BRP 0 FRONT', 'GBR BRP 0 BACK']",
            license: "['GBR DL 0 FRONT',  'GBR DLP 0 FRONT', 'GBR DL 0 BACK']",
        },
        Qatar:{
            default: "['NON PT 0 FRONT', 'QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK']",
            qrp: "['QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK']",
            passportMRZ:"['NON PT 0 FRONT']"
        },
        UAE:{
            default: "['NON PT 0 FRONT', 'ARE ID 0 FRONT', 'ARE ID 0 BACK']",
            passportMRZ:"['NON PT 0 FRONT']",
            uaeOldResidentCard: "['ARE ID 0 FRONT', 'ARE ID 0 BACK']",
            uaeSmartResidentCard : "['ARE ID 1 FRONT', 'ARE ID 1 BACK']"
        }

    }
    if(!cardType) {
        return cardTypeLists[tempCountry] ? cardTypeLists[tempCountry]['default'] : '' ;
    }
    return cardTypeLists[tempCountry] ? cardTypeLists[tempCountry][cardType] : '' ;
}
export async function updateGender(data,idNumber)
{
    // Get Records Gender then set Gender Value
    let genderType = ''

    if(data)
    {
        if(data!='' && store.getters.getField('identityInfo.cardType')!='URDU')
        {
            if (data == 'F') {
                genderType = 'Female'
            } else if (data == 'M') {
                genderType = 'Male'
            }
        }
        else if(store.getters.getField('identityInfo.cardType')=='URDU')
        {
            if (idNumber && idNumber!='') {
                const str = idNumber
                const last = str.charAt(str.length - 1)
                if (parseInt(last) % 2 == 0) {
                    genderType = 'Female'
                }
                // if the number is odd
                else {
                    genderType = 'Male'
                }
            }
        }
        if(genderType!='')
        {
            await getRecords('genders')

            let genderId = ''
            if (associateData) {
                associateData.forEach((element) => {
                    // const str = data
                    const str2 =
                        genderType.charAt(0).toUpperCase() +
                        genderType.slice(1)
                    if (element.title == str2) {
                        genderId = element._id
                    }
                })
            }
            store.commit('updateField', {
                key: 'basicInfo.gender',
                value: genderType,
            })
            store.commit('updateField', {
                key: 'basicInfo.genderId',
                value: genderId,
            })
        }
    }
}
export async function updateNationality(data , ocrApiResponse)
{ 
        let isCardType = ocrApiResponse && ocrApiResponse.card_type
        let isUkBrp = isCardType && cardTypeLists.UK.brp.includes(ocrApiResponse.card_type)
        let isUkPassPort = isCardType && cardTypeLists.UK.passport.includes(ocrApiResponse.card_type)
    if(data )
    {   
        await getRecords('nationalities')
        let natId = ''
        let nat = ''
        let str = data.toLowerCase()
        if( isCardType && ( isUkPassPort || isUkBrp ) && tempCountry == 'UK' ){
           let isReplaced = await replaceNationality(str,ocrApiResponse)
           str = isReplaced ? isReplaced.toLowerCase() : str.toLowerCase()
        }
        if (associateData) {
            associateData.forEach((element) => {
                if (element.title.toLowerCase() == str  || element.code.toLowerCase() === str){
                    natId = element._id
                    nat = element.title
                }              
            })
        }

        if(natId && nat){
        store.commit('updateField', {
            key: 'basicInfo.nationalityId',
            value: natId,
        })
        store.commit('updateField', {
            key: 'basicInfo.nationality',
            value: nat,
        })
        }
        return ''
    }
}
export async function updateName(data,ocrApiResponse,ocrData)
{
    if(data)
    {   let isSurname = ocrData && ocrData.surname
        let isCardType = ocrApiResponse && ocrApiResponse.card_type
        let isUkBrp = isCardType && cardTypeLists.UK.brp.includes(ocrApiResponse.card_type)
        let isUkPassport = isCardType && cardTypeLists.UK.passport.includes(ocrApiResponse.card_type)
        let isUkDl = isCardType && cardTypeLists.UK.license.includes(ocrApiResponse.card_type)
        let isPassportMRZ = cardTypeLists.UK.passportMRZ.includes(ocrApiResponse.card_type)
        if( isSurname && isCardType && ((( isUkPassport || isUkDl ) && tempCountry == 'UK' ) || isPassportMRZ ))
        {
            data = data + " "+ ocrData.surname
        }
        store.commit('updateField', {
            key: 'basicInfo.firstName',
            value: data,
        })
    }
}
export async function updateIdentity(data,expiry,ocrApiResponse)
{  try{
    let isCardType = ocrApiResponse && ocrApiResponse.card_type
    let isUkPassport = cardTypeLists.UK.passport.includes(ocrApiResponse.card_type)
    let isQatarRpBack = cardTypeLists.UK.qrp.includes(ocrApiResponse.card_type) && ocrApiResponse.card_type.includes("BACK")
    let isPassportMRZ = cardTypeLists.UK.passportMRZ.includes(ocrApiResponse.card_type)
    if(data){
            if(    
                isCardType && (  isUkPassport || isPassportMRZ )
              )
            {
                let idNumber = (data).replace('-','')
                idNumber = idNumber.replace('-','')
                store.commit('updateField', {
                    key: 'identityInfo.passport.number',
                    value: idNumber,
                })
                
            }
            else
            {   
                let idNumber = (data).replace('-','')
                idNumber = idNumber.replace('-','')
                store.commit('updateField', {
                    key: 'identityInfo.number',
                    value: idNumber,
                })
            }
    }
    if(expiry){
            if(  isCardType && (  isUkPassport || isPassportMRZ ) )
            {    
                let value = moment(expiry,'D-M-Y').isValid()? moment(expiry,'D-M-Y').format('YYYY-MM-DD'): ''
                store.commit('updateField', {
                    key: 'identityInfo.passport.expiryDate',
                    value:value,
                })
            }
            else
            {   let value = moment(expiry,'D-M-Y').isValid()? moment(expiry,'D-M-Y').format('YYYY-MM-DD'): ''
                store.commit('updateField', {
                        key: 'identityInfo.expiryDate',
                        value:value,
                    })
            
                // store.commit('updateField', {
                //     key: 'identityInfo.isLifetimeExpiry',
                //     value: "Yes",
                // })
            }
   }
  }catch(err){
    console.log("error for utils function updateIdentity()",err)
   }

}
export async function updateFatherName(data)
{
    if(data)
    {
        store.commit('updateField', {
            key: 'basicInfo.fatherName',
            value: data,
        })
    }
}
export async function updateDob(data)
{
    try{
        if(data)
        {  let value = moment(data,'D-M-Y').isValid()? moment(data,'D-M-Y').format('YYYY-MM-DD'): ''
            store.commit('updateField', {
                key: 'basicInfo.dateOfBirth',
                value:value,
            })
        }
   }catch(err){
    console.log("error for utils function updateDob()",err)
   }
}
export async function updatePicture(base64)
{   
    try{
        if(base64){
        const blob = await base64ToBlob(base64);
        var file = new File([blob], 'filename.png', { type: 'image/png' });
        

            const formData = new FormData();
            formData.append('file', file);
            formData.append('type', 'customers')
            let { data } = await axios.post(apiUrl + 'files/upload', formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${localStorage.getItem('vueauth_token')}`,
            },
        })
        data = data.data
        // console.log('this is the picture response --> ',data)
    
        if(data && data.fileName){
            store.commit('updateField', {
                key: 'documentInfo.ocrPicture.fileName',
                value: data.fileName,
            })
        }
        return true
      }
      return true
   }catch(error){
    console.log("error from updatePicture()",error)
   }

}

async function getRecords(association) {
    try {
        // fetch the list of associated configurations
        let { data } = await request({
            url: `/configurations/${association}`,
            params: {
                dataSegmentId: store.getters.dataSegmentId ? store.getters.dataSegmentId : localStorage.getItem('dataSegmentId'),
                status: 'active',
                perPage: 1000,
                ref: 'dropdown',
            },
        })

        // update the local list of options
        associateData = data.data
        //  console.log('associateData', associateData)
    } catch (error) {
        console.log(error)
    }
}

async function base64ToBlob(base64) {
    try{
    const raw = window.atob(base64);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
    }
    // console.log('this is unit array-->',uInt8Array)
    return new Blob([uInt8Array], { type: 'image/png' });
   }catch(err){
    console.log("error form base64ToBlob",err)
   }
}

async function replaceNationality(value,ocrApiResponse){
    if(value){
    let isCardType = ocrApiResponse && ocrApiResponse.card_type
    // variables for BRP
    let isUkBrp = isCardType && cardTypeLists.UK.brp.includes(ocrApiResponse.card_type)
    let UkBrpNationalities = {
        "uk" : "GB",
        "usa" : "US"

    }
    // variables for UK passports
    let isUkPassPort = isCardType && cardTypeLists.UK.passport.includes(ocrApiResponse.card_type)
    let UkPassportNationalities = {
        "british citizen" : "GB"
    } 

    if( isUkBrp && UkBrpNationalities[value] ){
          return UkBrpNationalities[value]
    }
    else if( isUkPassPort && UkPassportNationalities[value]) {
        return UkPassportNationalities[value]
    }

    }
    return ''
}

async function ocrFieldReset(cardType = null,data = null) {
//    let TypesForIdentityInfo = ['license','URDU','SMART','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
//    let TypesForPassport = ['passport', 'passportMRZ',]
//    let TypesForNationality = ['SMART','passport','passportMRZ','qrp','uaeOldResidentCard', 'uaeSmartResidentCard']
//    let TypesForGender = ['SMART','passport','passportMRZ']
//    let TypesForGeneric = ['license','SMART','URDU','passport','passportMRZ']
//    let selectedCardType = store.getters.getField("identityInfo.cardType");

      
   if(cardType){
       cardTypeList = [cardType]
    }
    else if(data && data.cardTypeList){
       cardTypeList = data.cardTypeList
    }
   if(cardTypesForGeneric.some(element=> cardTypeList.includes(element))){
            store.commit('updateField', {
                key: 'basicInfo.firstName',
                value: null,
            })
    
            store.commit('updateField', {
                key: 'basicInfo.dateOfBirth',
                value:null,
            })
            store.commit('updateField', {
                key: 'documentInfo.ocrPicture.fileName',
                value: null,
            })
    } 
    if(cardTypesForGender.some(element=> cardTypeList.includes(element))){
        store.commit('updateField', {
            key: 'basicInfo.gender',
            value: null,
        })
        store.commit('updateField', {
            key: 'basicInfo.genderId',
            value: null,
        })
    }
    if(cardTypesForNationality.some(element=> cardTypeList.includes(element)) && await isUpdateField('basicInfo.nationality')){
        store.commit('updateField', {
            key: 'basicInfo.nationalityId',
            value: null,
        })
        store.commit('updateField', {
            key: 'basicInfo.nationality',
            value: null,
        })
    }
    if( cardTypesForIdentityInfo.some(element=> cardTypeList.includes(element)) ){
        store.commit('updateField', {
            key: 'identityInfo.number',
            value: null,
        })
        store.commit('updateField', {
            key: 'identityInfo.expiryDate',
            value:null,
        })
    
    }

    if( cardTypesForPassport.some(element=> cardTypeList.includes(element)))
   {
        store.commit('updateField', {
            key: 'identityInfo.passport.number',
            value: null,
        })
        store.commit('updateField', {
            key: 'identityInfo.passport.expiryDate',
            value: null,
        })
        // store.commit('updateField', {
        //     key: 'identityInfo.isLifetimeExpiry',
        //     value: null,
        // })
    }
  
    if( cardTypesForFatherName.some(element=> cardTypeList.includes(element))){
        store.commit('updateField', {
            key: 'basicInfo.fatherName',
            value: null,
        })
    }
   
  }

async function isUpdateField(fieldKey){
    let fieldValue = store.getters.getField(fieldKey);
    let selectedCardType = store.getters.getField('identityInfo.cardType');
    let countries = ['UAE','Qatar']
    let cardTypes = [ 'QAT RP 0 FRONT', 'QAT RP 1 FRONT','QAT RP 0 BACK' , 'QAT RP 1 BACK',
                      'ARE ID 0 FRONT', 'ARE ID 0 BACK', 
                      'ARE ID 1 FRONT', 'ARE ID 1 BACK'
                    ]

    if( (countries.includes(tempCountry) && cardTypes.some(element=> cardTypeList.includes(element)) ) || !fieldValue || !selectedCardType ){
      return true
    }else if ( !countries.includes(tempCountry) ){
       return true
    }
    return false
 }

export function encrypt(data,stringify=true)
 {
     if(stringify)
     {
         data = JSON.stringify(data)
     }
     let enc = CryptoJS.AES.encrypt(
         data,
         process.env.VUE_APP_IDENTIFIER
     ).toString()

     return enc
 }
export function decrypt(data)
{
    let dec = CryptoJS.AES.decrypt(data, process.env.VUE_APP_IDENTIFIER).toString(CryptoJS.enc.Utf8)
    dec = JSON.parse(dec)

    return dec
}

export function isObjectEmpty(obj){
    if (Object.keys(obj).length === 0) {
        return true;
    }

    // Check if all values in the object are empty
    return Object.values(obj).every(value => 
        value === null || value === undefined || value === '' || 
        (typeof value == 'string' && value.trim() == '') ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && value !== null && Object.keys(value).length === 0)
    );
}